/* Lockett Labs Events: Trade with us.
   The shows taking applications (live from the events desk), what a table
   costs, and the way back into a trader's dashboard. The application and the
   dashboard are their own pages now; an old email link (#portal=<token>)
   that lands here is handed straight on to the dashboard. Everything the
   desk sends back goes on the page as text, never as HTML. */
(function () {
  'use strict';
  var EV = window.EV;
  var root = document.querySelector('[data-ev-traders]');
  if (!EV || !root) return;
  var el = EV.el;
  var API = EV.apiBase(root.getAttribute('data-api') || '');
  var APPLY = root.getAttribute('data-apply-url') || '/pages/events?view=vendor-apply';
  var DASH = root.getAttribute('data-dash-url') || '/pages/events?view=vendor-dashboard';
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  /* An emailed link from before the dashboard had its own page. */
  (function () {
    var m = location.hash.match(/^#portal=([A-Za-z0-9_-]{40,60})(.*)$/);
    if (m) location.replace(DASH + '#portal=' + m[1] + (m[2] || ''));
  })();

  function join(base, key, val) { return base + (base.indexOf('?') > -1 ? '&' : '?') + key + '=' + encodeURIComponent(val); }
  function niceDate(iso, opts) {
    if (!iso) return '';
    var d = new Date(iso);
    return isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-GB', opts || { weekday: 'short', day: 'numeric', month: 'long', year: 'numeric' });
  }
  function daysTo(iso) {
    var d = iso ? new Date(iso) : null;
    if (!d || isNaN(d.getTime())) return null;
    return Math.ceil((d.getTime() - Date.now()) / 86400000);
  }

  /* ---------------------------------------------------------------- hero facts */
  function paintStats(list) {
    var open = list.filter(function (e) { return e.applications && e.applications.accepting; });
    var pool = open.length ? open : list;
    var prices = [];
    pool.forEach(function (e) { (e.tables || []).forEach(function (t) { if (t.price > 0) prices.push(t.price); }); });
    var pd = root.querySelector('[data-evt-price]');
    if (pd) pd.textContent = prices.length ? EV.money(Math.min.apply(null, prices)) + (pool[0] && pool[0].priceNote ? ' ' + pool[0].priceNote : '') : 'On approval';
    var sd = root.querySelector('[data-evt-state]');
    if (sd) {
      var sched = list.filter(function (e) { return e.applications && e.applications.state === 'scheduled'; });
      sd.textContent = open.length ? 'Open for ' + open.length + (open.length === 1 ? ' show' : ' shows')
        : sched.length ? 'Open ' + niceDate(sched[0].applications.opensAt, { day: 'numeric', month: 'long' }) : 'Closed for now';
      sd.classList.toggle('is-open', !!open.length);
    }
  }

  /* ---------------------------------------------------------------- shows taking applications */
  function stub(iso) {
    var d = iso ? new Date(iso) : null;
    return el('span', { class: 'evx-open__date' }, el('b', { text: d ? String(d.getDate()) : '?' }), el('span', { text: d ? d.toLocaleDateString('en-GB', { month: 'short' }) : 'TBC' }), el('small', { text: d ? d.toLocaleDateString('en-GB', { weekday: 'short' }) : '' }));
  }
  function openCard(e) {
    var a = e.applications || {};
    var state = { open: ['Open', 'is-open'], waitlist: ['Reserve list', 'is-soon'], scheduled: ['Opens ' + niceDate(a.opensAt, { day: 'numeric', month: 'short' }), 'is-soon'], full: ['Full', 'is-closed'], closed: ['Closed', 'is-closed'] }[a.state] || ['Closed', 'is-closed'];
    var facts = el('ul', { class: 'evx-open__facts' });
    var add = function (ic, txt, cls) { if (txt) facts.append(el('li', { class: cls || '' }, EV.icon(ic), el('span', { text: txt }))); };
    add('pin', [e.venue, e.town].filter(Boolean).join(', '));
    if (a.accepting) {
      var dl = daysTo(a.closesAt);
      add('clock', a.closesAt ? 'Closes ' + niceDate(a.closesAt, { day: 'numeric', month: 'long' }) + (dl != null && dl <= 14 ? ' (' + (dl <= 1 ? 'tomorrow' : 'in ' + dl + ' days') + ')' : '') : 'Open until full', dl != null && dl <= 7 ? 'is-hot' : '');
      if (a.remaining != null) add('ticket', a.remaining + (a.remaining === 1 ? ' place left' : ' places left'), 'is-hot');
      else if (a.tablesLeft != null) add('stall', a.tablesLeft + (a.tablesLeft === 1 ? ' table left' : ' tables left'), 'is-hot');
    }
    if (e.tablesFrom) add('pound', 'Tables from ' + e.tablesFrom + (e.priceNote ? ' ' + e.priceNote : ''));
    if (e.traders && e.traders.listed) add('users', e.traders.listed + (e.traders.listed === 1 ? ' trader confirmed' : ' traders confirmed'));
    var perks = el('div', { class: 'evx-open__perks' });
    perks.append(el('span', null, EV.icon('dash'), 'Dashboard'), el('span', null, EV.icon('poster'), 'Promo kit'));
    if (e.perks && e.perks.whatsapp) perks.append(el('span', { class: 'is-wa' }, EV.icon('whatsapp'), "Traders' group"));
    var cta = a.accepting
      ? el('a', { class: 'ev-btn ev-btn--primary', href: join(APPLY, 'show', e.handle) }, a.state === 'waitlist' ? 'Join the reserve list' : 'Apply for this show', EV.icon('arrow', 'ev-arr'))
      : el('span', { class: 'ev-btn', 'aria-disabled': 'true' }, state[0]);
    return el('article', { class: 'evx-open__card' + (a.accepting ? ' is-live' : '') },
      stub(e.startsAt),
      el('div', { class: 'evx-open__body' },
        el('div', { class: 'evx-open__top' }, el('span', { class: 'ev-dotless ' + state[1], text: state[0] }), a.label && !a.accepting ? el('small', { text: a.label }) : null),
        el('h3', { text: e.title }),
        el('p', { class: 'evx-open__when', text: e.dateLabel }),
        facts, perks),
      el('div', { class: 'evx-open__cta' }, cta));
  }
  function paintOpen(list) {
    var box = root.querySelector('[data-evt-open]');
    if (!box) return;
    box.textContent = '';
    var shows = list.slice().sort(function (x, y) { return (y.applications.accepting ? 1 : 0) - (x.applications.accepting ? 1 : 0); });
    if (!shows.length) {
      box.append(el('div', { class: 'evx-empty' }, EV.icon('cal'), el('b', { text: 'No dates taking applications right now' }), el('p', { text: 'New dates open here first. Join the Discord or the on-sale email on the events page to hear when.' }), el('a', { class: 'ev-btn', href: '/pages/events#community' }, 'Get told when they open')));
      return;
    }
    shows.forEach(function (e) { box.append(openCard(e)); });
  }

  /* ---------------------------------------------------------------- prices */
  function paintPrices(list) {
    var open = list.filter(function (e) { return e.applications && e.applications.accepting; });
    var show = (open.length ? open : list)[0];
    var sec = root.querySelector('[data-evt-prices-sec]');
    if (!sec || !show || !(show.tables || []).length) return;
    sec.hidden = false;
    root.querySelector('[data-evt-prices-title]').textContent = 'Tables at ' + show.title;
    root.querySelector('[data-evt-prices-note]').textContent = [show.dateLabel, show.priceNote ? 'Prices ' + show.priceNote : ''].filter(Boolean).join(' · ');
    var box = root.querySelector('[data-evt-prices]');
    box.textContent = '';
    var grid = el('div', { class: 'evt-prices__tables' });
    show.tables.forEach(function (t) {
      grid.append(el('div', { class: 'evt-price' },
        t.size ? el('span', { class: 'evt-price__size', text: t.size }) : null,
        el('b', { class: 'evt-price__name', text: t.name }),
        el('span', { class: 'evt-price__p' }, t.price > 0 ? EV.money(t.price) : 'On approval', t.price > 0 ? el('small', { text: ' per table' }) : null),
        t.description ? el('span', { class: 'evt-price__d', text: t.description }) : null,
        t.maxQty > 1 ? el('span', { class: 'evt-price__q', text: 'Up to ' + t.maxQty + ' per trader' }) : null,
        el('a', { class: 'evx-price__go', href: join(APPLY, 'show', show.handle) }, 'Apply with this table', EV.icon('arrow'))));
    });
    box.append(grid);
    var extras = show.extras || [];
    var inc = show.info && show.info.included;
    if (extras.length || inc) {
      var side = el('div', { class: 'evt-prices__more' });
      if (inc) side.append(el('p', { class: 'evt-prices__inc' }, el('b', { text: 'Every table includes ' }), document.createTextNode(inc)));
      if (extras.length) {
        var ul = el('ul', { class: 'evt-extras' });
        extras.forEach(function (x) {
          ul.append(el('li', null, el('span', null, el('b', { text: x.name }), x.description ? el('small', { text: x.description }) : null), el('span', { class: 'evt-extras__p' + (x.price > 0 ? '' : ' is-free'), text: x.priceLabel })));
        });
        side.append(el('div', null, el('h3', { class: 'evt-extras__h', text: 'Extras' }), ul));
      }
      box.append(side);
    }
  }

  /* ---------------------------------------------------------------- the dashboard link */
  var linkForm = root.querySelector('[data-evt-linkform]');
  if (linkForm) {
    linkForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailIn = linkForm.querySelector('input[type=email]');
      var msg = linkForm.querySelector('[data-evt-linkmsg]');
      var b = linkForm.querySelector('button[type=submit]');
      msg.hidden = true;
      if (!EMAIL.test(emailIn.value.trim())) { msg.hidden = false; msg.className = 'evf-err'; msg.textContent = 'Enter the email you applied with.'; emailIn.focus(); return; }
      b.classList.add('is-busy');
      EV.api(API, 'public.php?action=portal-link', { method: 'POST', body: { email: emailIn.value.trim() } }).then(function (r) {
        msg.hidden = false; msg.className = 'ev-form-ok'; msg.textContent = r.message;
      }).catch(function (err) {
        msg.hidden = false; msg.className = 'ev-form-bad'; msg.textContent = err.message;
      }).then(function () { b.classList.remove('is-busy'); });
    });
  }

  /* ---------------------------------------------------------------- go */
  if (!API) return;
  EV.api(API, 'public.php?action=events').then(function (d) {
    var list = d.events || [];
    paintStats(list);
    paintOpen(list);
    paintPrices(list);
  }).catch(function () {
    var box = root.querySelector('[data-evt-open]');
    var mail = root.getAttribute('data-contact') || '';
    if (box) {
      box.textContent = '';
      box.append(el('div', { class: 'evx-empty' }, EV.icon('info'), el('b', { text: 'The events desk is not answering' }),
        el('p', null, 'Please try again in a few minutes', mail ? ', or email ' : '.', mail ? el('a', { href: 'mailto:' + mail, text: mail }) : null),
        el('button', { type: 'button', class: 'ev-btn', onclick: function () { location.reload(); } }, 'Try again')));
    }
    ['[data-evt-price]', '[data-evt-state]'].forEach(function (s) { var n = root.querySelector(s); if (n) n.textContent = 'See below'; });
  });
})();
